<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      border
      resizable
      :loading="loading"
      :toolbar-config="tableToolbar"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span class="side-frame-text">执行明细</span>
          </div>
        </slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.quartzTaskStatus === 'E'
              ? 'warning'
              : row.quartzTaskStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_quartzTaskStatus }}
        </el-tag>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: { quartzTaskCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: tableColumns(this),
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.getData() },
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.quartzTaskCode) return
      this.loading = true
      this.$api
        .sysQuartzTaskLogListApi({ quartzTaskCode: this.quartzTaskCode })
        .then((res) => {
          this.tableData = res.body.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
